<script>
    import "../project-card/projectCard.css";
    import {formatUnits} from "ethers/lib/utils";
    import {getProjectMetaService} from "../../../services/api";
    import { BASE_URL, PROJECT_STATUSES, COMPLETE_TIME_FORMAT, PARTIAL_TIME_FORMAT} from "../../constants/constants";
    import { projectDetail } from "../../store";
    import {link} from 'svelte-spa-router'
    import {
        formateToPrecision,
        formatNumberComma,
        getAfterTimestampDate,
        getAfterTimeStampStrapi,
        getRelativeTime,
        getTime,
        getTimeDifference,
        getTokenPrice
        
    } from "../../utils";
    import ProgressBar from "../progressbar/ProgressBar.svelte";
    import {createEventDispatcher, onDestroy} from "svelte";
    const dispatch =  createEventDispatcher();


    export let project
    let projectMeta, liveProjectTimeRemaining, projectTier = ""

    let saleCardDetails = {
        raiseTarget: "",
        totalSupply: "",
        startTime: "",
        endTime: "",
        unitsAvailable: "",
        totalRaised: "",
        price: ""
    }



    let countDownTimer;

    const setProjectData = async () => {
        if(project.sale_address){
            const {data} = await getProjectMetaService(project.sale_address);
            projectMeta = data.sales[0];
            if (projectMeta.saleStatus > 1) {
                dispatch('completedProject', {
                    project, timestamp: projectMeta.endEvent.timestamp
                });
            }
            if (data.sales[0]) setSaleData(data.sales[0]);
        } else {
            project.progress_bar_status = project.progress_bar_status ?? 0;
            saleCardDetails = {
                walletCap: project.individual_purchase_limit,
                raiseTarget: project.project_raise_target,
                totalSupply: project.total_available_token,
                startTime: new Date(project.project_start_time).getTime(),
                endTime: new Date(project.project_end_time).getTime(),
                totalRaised: (project.progress_bar_status * project.total_available_token / 100) * project.project_token_price,
                price: project.project_token_price,
                tokenName: project.token_name,
                tokenSymbol: project.token_symbol,
                percentRaised: project.progress_bar_status,
            }

            startTimer(() => {
                liveProjectTimeRemaining = getTimeDifference(saleCardDetails.endTime);
            })
          
        }
    }

    const startTimer = (callback) => {
        countDownTimer = setInterval(callback, 1000);
    }

    const setSaleData = (sale) => {
        saleCardDetails = {
            raiseTarget: Number(formatUnits(sale.minimumRaise, sale.reserve.decimals)),
            totalSupply: Number(+formatUnits(sale.token.totalSupply, sale.token.decimals)),
            startTime: sale.canStartStateConfig,
            endTime: sale.endEvent ?? sale.canEndStateConfig,
            unitsAvailable: Number((+formatUnits(sale.unitsAvailable, sale.token.decimals))),
            totalRaised: Number((+formatUnits(sale.totalRaised, sale.reserve.decimals))),
            price: getTokenPrice(sale),
            tokenName: sale.token.name,
            tokenSymbol: sale.token.symbol,
            percentRaised: sale.percentRaised,
            saleStatus: sale.saleStatus
        }

        if(sale.startEvent && !countDownTimer){
            startTimer(()=>{
                const {timeRemaining} = getTime(projectMeta);
                liveProjectTimeRemaining = timeRemaining
            })
        }
    }
    setProjectData();


    onDestroy(() => {
        if(countDownTimer)
            clearInterval(countDownTimer)
    })

</script>

<div class="slider-wrapper flex">
    <a class="flex column-direction" on:click={()=> {projectDetail.set(project)}} id="{project.id}" href={`/project-details/${project.id}/${project.sale_address ? project.sale_address : "" }`} use:link>
    <div class="card column-direction">
        <div class="card-body">
            <figure>
                <img src={`${BASE_URL+project.project_cover?.data?.attributes?.formats?.thumbnail.url}`} alt="cardImage">
                {#if project.sale_address}
                <span class="tier">{projectTier ? projectTier : "Public"}</span>
                {/if}
                <span class={`status ${project.project_status ? project.project_status.toLowerCase() : ""}`}>{project.project_status === PROJECT_STATUSES.LIVE ? "Live" : project.project_status}</span>
            </figure>
            <section class="text-left">
                <h2>{project.project_name}</h2>
                <p>{project.project_description}</p>
                <ul class="list-none flex column-direction">
                    <li class="flex">
                        <span>Raise Target </span>
                        <span class="ml-auto">${PROJECT_STATUSES.UPCOMING === project.project_status ? formatNumberComma(project.project_raise_target) : formatNumberComma(saleCardDetails.raiseTarget)}</span>
                    </li>
                    <li class="flex">
                        <span>Token Price</span>
                        <span class="ml-auto">${PROJECT_STATUSES.UPCOMING === project.project_status ? formateToPrecision(project.project_token_price) ?? '' : formateToPrecision(saleCardDetails.price) ?? ''}</span>
                    </li>
                    {#if PROJECT_STATUSES.LIVE === project.project_status && saleCardDetails.endTime}
                        <li class="flex">
                            <span>Time Remaining</span>
                            {#if project.sale_address}
                                <span class="ml-auto">{liveProjectTimeRemaining ? liveProjectTimeRemaining : getRelativeTime(saleCardDetails.endTime) }</span>
                            {:else}
                                <span class="ml-auto">{ liveProjectTimeRemaining  }</span>
                            {/if}
                        </li>
                    {/if}
                    {#if PROJECT_STATUSES.UPCOMING === project.project_status}
                        <li class="flex">
                            <span>Start Time</span>
                            <span class="ml-auto">{getAfterTimeStampStrapi(project.project_start_time, COMPLETE_TIME_FORMAT)}</span>
                        </li>
                        <li class="flex">
                            <span>End Time</span>
                            <span class="ml-auto">{getAfterTimeStampStrapi(project.project_end_time, COMPLETE_TIME_FORMAT)}</span>
                        </li>
                    {/if}
                    {#if PROJECT_STATUSES.COMPLETED === project.project_status && saleCardDetails.startTime && saleCardDetails.endTime}
                        <li class="flex">
                            <span>Date Ending</span>
                            <span class="ml-auto">{project.sale_address ? getAfterTimestampDate(saleCardDetails.endTime, COMPLETE_TIME_FORMAT) : getAfterTimeStampStrapi(saleCardDetails.endTime, COMPLETE_TIME_FORMAT)}</span>
                        </li>
                    {/if}
                    {#if PROJECT_STATUSES.UPCOMING !== project.project_status}
                        <li>
                            <ProgressBar {saleCardDetails} />
                        </li>
                    {/if}
                </ul>
            </section>
        </div>
    </div>
    </a>
</div>
